import type { ClassDefinition } from '../../shared/game/class-types.js';

// Songweaver 3.0 draft, level 1 only.
export const songweaver: ClassDefinition = {
  id: 'songweaver', name: 'Songweaver',
  summary: 'A voice woven with magic, bolstering allies and shaping the wind into song.',
  keyStats: ['will', 'intelligence'], hitDie: 8, startingHp: 13,
  saves: { advantage: ['will'], disadvantage: ['strength'] },
  armor: ['cloth', 'leather'], weapons: ['dexterity'], weaponTypes: ['wand'],
  startingGear: ['Adventurer’s Garb', 'Instrument', 'Dagger', 'Mirror'], defaultStance: 'keep-distance',
  abilities: [
    {
      id: 'vicious-mockery', spell: true, name: 'Vicious Mockery', level: 1, actions: 1, target: 'enemy', autocast: true, autoAttack: true,
      description: 'Range 12. Deal 1d6 + INT psychic damage, ignoring Armor. On hit, Taunt the target for one combat round.',
    },
    {
      id: 'razor-wind', spell: true, name: 'Razor Wind', level: 1, actions: 1, target: 'enemy', maxTargets: 2, autocast: true, autoAttack: true,
      description: 'Wind cantrip · Range 12 · 2d4 slashing. One target grants advantage; two adjacent targets share one attack and damage roll.',
    },
    {
      id: 'breath-of-life', spell: true, name: 'Breath of Life', level: 1, actions: 1, target: 'ally', dyingTarget: true, autocast: true,
      description: 'Wind cantrip · Range 6 · Restore 1d4 HP to a Dying creature, the Songweaver included. On a result of 4, they also regain 1 action.',
    },
    {
      id: 'songweavers-inspiration', name: 'Songweaver’s Inspiration', level: 1, actions: 0, target: 'ally', reaction: true,
      usesPerSafeRest: { stat: 'will', multiplier: 2 },
      description: 'The AI may let another ally reroll one die or increase its result by 1 when that can change a major outcome. Never affects the Songweaver’s own rolls.',
    },
  ],
  passives: [{
    id: 'windbag', name: 'Windbag', level: 1,
    description: 'You know Wind cantrips and the Vicious Mockery spell.',
  }],
};
